var React = require('react');

function IgloHouse (props) {
    return React.createElement("svg",props,[React.createElement("path",{"opacity":"0.7","d":"M216.5 91.3462L120.5 110.962L180 244.231L281.5 200.385L216.5 91.3462Z","fill":"#324843","key":0}),React.createElement("path",{"opacity":"0.3","d":"M57 210.192L179.5 243.654L120 110.961L57 210.192Z","fill":"#324843","key":1}),React.createElement("path",{"d":"M120 110.385L179.5 243.654","stroke":"#324843","fill":"transparent","key":2}),React.createElement("path",{"d":"M179 244.231L55.5 210.769L120 110.385L216.5 90.7693L281 200.385L179 244.231Z","stroke":"#324843","strokeWidth":"3","strokeLinejoin":"round","fill":"transparent","key":3})]);
}

IgloHouse.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 320 320","fill":"none"};

module.exports = IgloHouse;

IgloHouse.default = IgloHouse;
